import React from "react";
import personne from "../../images/icons/1.png";
import mairies from "../../images/icons/2.png";
import usine from "../../images/icons/3.png";

export interface StatisticHomeSectionProps {
  className?: string;
  img1?: string;
  img2?: string;
  img3?: string;
  title1?: string;
  title2?: string;
  title3?: string;
  val1?: string;
  val2?: string;
  val3?: string;
}

const PedagoqiueStatsSection: React.FC<StatisticHomeSectionProps> = ({
  className,
  img1 = personne,
  img2 = mairies,
  img3 = usine,
  title1 = "Transport",
  title2 = "Animation",
  title3 = "Groupe de 30",
  val1 = "Organisation du transport aller-retour depuis votre établissement jusqu’à notre espace pédagogique.",
  val2 = "Conférenciers spécialisés et activités adaptées au niveau scolaire des élèves (CP à CM2).",
  val3 = "Organisation du transport aller-retour depuis votre établissement jusqu’à notre espace pédagogique.",
}) => {
  const stats = [
    { img: img1, title: title1, val: val1 },
    { img: img2, title: title2, val: val2 },
    { img: img3, title: title3, val: val3 },
  ];

  return (
    <div
      className={`relative p-12 bg-[rgba(22,153,118,0.3)] ${className}`}
      style={{ zIndex: 0 }}
    >
      <div className="mb-10 text-xl font-bold text-center text-black">
        Ce que comprend la visite ?
      </div>

      {/* Container for the stats items */}
      <div className="flex flex-wrap justify-center gap-10 mb-10 xl:gap-0 xl:flex-nowrap ">
        {stats.map((item, index) => (
          <div
            key={index}
            className={`flex flex-col items-center text-center max-w-[254px] px-4  `}
          >
            <div
              className="w-[65px] h-[65px] bg-primary"
              style={{
                mask: `url(${item.img}) no-repeat center`,
                maskSize: "contain",
                WebkitMask: `url(${item.img}) no-repeat center`,
                WebkitMaskSize: "contain",
              }}
            />
            <div className="mb-2 text-lg font-bold text-black">
              {item.title}
            </div>
            <div className="text-sm text-black">{item.val}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PedagoqiueStatsSection;
